<template>
  <div v-if="appParams && appParams.staticTranslations" class="itb-home">
    <hero-cards :cards="heroCards1"></hero-cards>

    <section id="itb-home-benefits">
      <div class="container">
        <div
          id="itb-home-benefits-bubble-left"
          v-lazy:background-image="
            '/images/' +
            languageDependantImageSubFolder +
            '/home-benefits-bubble-left.webp'
          "
        ></div>
        <div
          id="itb-home-benefits-bubble-middle"
          v-lazy:background-image="
            '/images/articles/home-benefits-bubble-middle.webp'
          "
        ></div>
        <div
          id="itb-home-benefits-bubble-right"
          v-lazy:background-image="
            '/images/' +
            languageDependantImageSubFolder +
            '/home-benefits-bubble-right.webp'
          "
        ></div>
        <div class="row">
          <div class="col-12 col-md-6 itb-left-box">
            <div
              class="itb-top-image"
              v-lazy:background-image="
                '/images/articles/home-benefits-left.webp'
              "
            ></div>
            <div class="itb-middle-text itb-bg-red">
              <h2 class="itb-home-benefits-option-title">
                {{
                  appParams.staticTranslations["home.home_benefits_title_left"]
                }}
              </h2>
              <div class="m-0 text-white">
                <ul
                  style="font-size: 1.25rem; margin: 0; padding-left: 1.35rem"
                >
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_left_cleanvar_01"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_left_cleanvar_02"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_left_cleanvar_03"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_left_cleanvar_04"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_left_cleanvar_05"
                      ]
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div
              class="itb-top-image"
              v-lazy:background-image="
                '/images/articles/home-benefits-right.webp'
              "
            ></div>
            <div class="itb-middle-text itb-bg-orange">
              <h2 class="itb-home-benefits-option-title">
                {{
                  appParams.staticTranslations["home.home_benefits_title_right"]
                }}
              </h2>
              <div class="m-0 text-white">
                <ul
                  style="font-size: 1.25rem; margin: 0; padding-left: 1.35rem"
                >
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_right_cleanvar_01"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_right_cleanvar_02"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_right_cleanvar_03"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_right_cleanvar_04"
                      ]
                    }}
                  </li>
                  <li>
                    {{
                      appParams.staticTranslations[
                        "home.home_benefits_text_right_cleanvar_05"
                      ]
                    }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <hero-cards :cards="heroCards2"></hero-cards>

    <section id="itb-home-insta">
      <div class="container text-center">
        <h2 class="mb-5">
          {{ appParams.staticTranslations["home.instagram_news"] }}
        </h2>
        <insta-posts></insta-posts>
        <a
          class="btn btn-primary itb-btn-icon mt-4"
          :href="appParams.general_instagram"
          target="_blank"
        >
          {{ appParams.staticTranslations["home.see_our_instagram"] }}
          <img
            src="/images/icons/4soft_icon_angle-right.svg"
            :alt="appParams.staticTranslations['home.see_our_instagram']"
            class="itb-icon itb-angle-right-icon"
          />
        </a>
      </div>
    </section>
    <section class="mt-5" v-if="youtubeUrl">
      <div class="container">
        <div class="row">
          <div
            class="col-12 d-flex flex-column align-items-center itb-youtube-video"
          >
            <h2 class="text-center">
              {{ appParams.staticTranslations["general.samples_of_our_work"] }}
            </h2>
            <div
              class="d-flex justify-content-center align-items-center itb-youtube-warning-wrap mb-5"
            >
              <p
                class="mb-0 itb-youtube-warning"
                :class="{
                  'itb-youtube-warning-highlight': isYoutubeHighlighted,
                }"
                ref="youtubeWarning"
              >
                {{ appParams.staticTranslations["general.youtube_warning"] }}
                {{ appParams.staticTranslations["general.see_youtube_policy"] }}
                <a href="https://policies.google.com/privacy" target="_blank"
                  >{{
                    appParams.staticTranslations["general.youtube_policy"]
                  }}.</a
                >
              </p>
              <button
                class="btn btn-secondary ml-2"
                :disabled="youtubePermit"
                @click="allowYoutubeVideos"
              >
                {{ appParams.staticTranslations["cookies.accept"] }}
              </button>
            </div>
            <div
              v-if="!youtubePermit"
              class="itb-youtube-image itb-youtube-video-homepage d-flex justify-content-center align-items-center"
              @click="warningHighlight"
            >
              <img src="/images/youtube-logo.png" alt="youtube-logo" />
            </div>
            <iframe
              class="itb-youtube-video-homepage"
              :src="youtubeUrl + '&autoplay=1&loop=1'"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              v-else
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      heroCards1: [],
      heroCards2: [],
      pageParams: [],
      randomYoutubeVideoLinks: [],
      youtubePermit: false,
      isYoutubeHighlighted: false,
      youtubeUrl: "",
    };
  },

  created() {
    this.getVideoLink();
  },

  mounted() {
    axios
      .get("/getHomePage")
      .then((response) => {
        this.heroCards1 = response.data.heroCards1;
        this.heroCards2 = response.data.heroCards2;
        this.pageParams = response.data.params;

        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({ appParams: "getAppParams" }),

    languageDependantImageSubFolder() {
      var folder = "articles";
      if (this.$store.state.domainLanguage != "en") {
        folder = "articles_" + this.$store.state.domainLanguage;
      }
      return folder;
    },
  },

  methods: {
    ...mapActions(["setPageParams", "setFormParams"]),

    async getVideoLink() {
      await axios
        .get("/get-video-link")
        .then((response) => {
          this.youtubeUrl = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    warningHighlight() {
      this.isYoutubeHighlighted = true;
      setTimeout(() => {
        this.isYoutubeHighlighted = false;
      }, 1500);
    },

    allowYoutubeVideos() {
      this.youtubePermit = true;
    },
  },
};
</script>
